import React from 'react'
import useAccordion from '../hooks/use-accordion'
import { useValue } from '@morningtrain/react-resources'
import Collapse from './Collapse'
import ToggleAccordionOnClickPipeline from '../pipelines/ToggleAccordionOnClickPipeline'
import classNames from 'classnames'
import * as UI from 'ui'

export default function AccordionModelItem ({
  children,
  modelName = 'id',
  title,
  subtitle = null,
  transparent = false,
  defaultOpen = false
}) {
  const key = useValue(modelName)

  const accordion = useAccordion()
  const isAccordionActive = accordion.isActive(key)

  React.useEffect(() => {
    if (defaultOpen === true) {
      accordion.open(key)
    }
  }, [])

  const _className = classNames(
    { 'bg-white': transparent === false },
    'cursor-pointer py-4 border-t'
  )

  return (
    <div>
      <ToggleAccordionOnClickPipeline name={key}>
        <UI.SpaceBetween className={_className}>
          <UI.Text weight='medium' size='base'>
            {title}
          </UI.Text>
          <div className='flex space-x-8 items-center'>
            {subtitle}
            {isAccordionActive
              ? (
                <UI.Icons.Down className='w-2 h-2'/>
              )
              : (
                <UI.Icons.Right className='w-2 h-2'/>
              )}
          </div>
        </UI.SpaceBetween>
      </ToggleAccordionOnClickPipeline>
      <Collapse name={key}>
        {children}
      </Collapse>
    </div>
  )
}
